export enum StoreCategoryType {
  GROUP = 'GROUP',
  SINGLE = 'SINGLE',
}

export enum StoreCategoryAlias {
  TRADITIONAL_MARKET = 'TRADITIONAL_MARKET',
}
